import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const TopicLoadingCardBase = ({ isStatic, children }) => (
  <Card px={0} py={0} width="100%" height="100%">
    <Box display="block">
      {/* Header */}
      <Box>
        <SkeletonWrapper isStatic={isStatic} height={175} width="100%" />
      </Box>

      {/* Body */}
      <Box display="block" mt="14px" px={4} pb={6}>
        <Skeleton isStatic={isStatic} height={48} width="100%" />

        <Skeleton isStatic={isStatic} height={34} width="100%" mt={2} />

        {children}
      </Box>
    </Box>
  </Card>
);

TopicLoadingCardBase.propTypes = {
  isStatic: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

TopicLoadingCardBase.defaultProps = {
  isStatic: false,
};

export default TopicLoadingCardBase;

const SkeletonWrapper = styled(Skeleton)`
  border-top-left-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
  border-top-right-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
`;
